import React, { useEffect } from 'react';
import styled from 'styled-components';

import { WorkArea } from '@xsolla/ui-core';

import { HelpSteps, LoginStartPageFeatures, LoginStartPageHeader } from '../../components';
import { Separator } from '../../components/ui';
import { useConfig } from '../../contexts/config';
import { useAppSettings } from '../../contexts/settings';

const LoginStartPageWrapper = styled.div`
  color: ${(p) => p.theme.colors.muted};
`;

const LoginStartPage = (): JSX.Element => {
  const { hideTabs, showTabs } = useAppSettings();
  const { xsollaAnalytics } = useConfig();

  useEffect(() => {
    xsollaAnalytics.sendOpen('login_pa_module__dashboard', 'open', {
      type: 'start_page'
    });
  }, []);

  useEffect(() => {
    hideTabs();
    return () => showTabs();
  }, []);

  return (
    <WorkArea>
      <LoginStartPageWrapper>
        <LoginStartPageHeader />

        <LoginStartPageFeatures />

        <Separator />

        <HelpSteps />
      </LoginStartPageWrapper>
    </WorkArea>
  );
};

export default LoginStartPage;
